import { Vue, i18n, wemeikPopup } from './core'
import Rails from '@rails/ujs'
import checkoutStore from './stores/checkout'
import { calculateCustomerLocation, saveCurrentPosition } from '../utils/geolocation'

const $el = document.getElementById('branch-selector')

if ($el) {
  const BRANCHES_PATH = $el.dataset.branches
  const LOCALITIES_PATH = $el.dataset.localities

  new Vue({
    el: $el,
    i18n,
    data: {
      branches: [],
      localities: [],
      mapUrl: '',
      position: {},
      selectedBranchId: checkoutStore.state.branchId,
      selectedLocalityId: checkoutStore.state.localityId,
      lastLocalityIdSearched: null,
      areLoadingLocalities: true,
      areLoadingBranches: true
    },
    mounted () {
      this.calculateCustomerLocation()
        .then((position) => {
          this.position = position
          saveCurrentPosition(position)
        })
        .finally(() => {
          this.loadLocalities()
        })
    },
    watch: {
      selectedBranchId () {
        this.updateMapURL()
        if (this.selectedBranchId) {
          checkoutStore.setCheckoutSettings({ branchId: this.selectedBranchId, localityId: this.selectedLocalityId })
        }
      },
      selectedLocalityId () {
        if (this.selectedLocalityId) {
          this.loadBranches()
          checkoutStore.setCheckoutSettings({ localityId: this.selectedLocalityId })
        }
      }
    },
    methods: {
      calculateCustomerLocation: calculateCustomerLocation,
      confirm () {
        wemeikPopup({
          title: this.$t('alert.success'),
          text: '',
          icon: 'success'
        })

        if (window.location.href.includes('/branches')) {
          setTimeout(() => {
            window.location.href = '/products'
          }, 1500)
        } else {
          window.jQuery('#branchModal').modal('hide')

          setTimeout(() => {
            wemeikPopup.close()
          }, 1500)
        }
      },
      loadBranches () {
        if (this.selectedLocalityId !== this.lastLocalityIdSearched) {
          this.areLoadingBranches = true
          const self = this
          Rails.ajax({
            url: BRANCHES_PATH,
            type: 'GET',
            dataType: 'json',
            data: `locality_id=${self.selectedLocalityId}&latitude=${self.position.latitude}&longitude=${self.position.longitude}`,
            success: (branches) => {
              self.lastLocalityIdSearched = self.selectedLocalityId
              self.branches = branches
              if (Array.isArray(self.branches) && self.branches.length > 0) {
                if (self.selectedBranchId) {
                  self.updateMapURL()
                } else {
                  const selectedBranch = self.branches.find((b) => b.nearest)
                  if (selectedBranch) {
                    self.selectedBranchId = selectedBranch.id
                  } else {
                    self.selectedBranchId = self.branches[0].id
                  }
                }
              }
            },
            error: (error) => {
              console.error('Error loading branches: ', error)
            },
            complete: () => {
              self.areLoadingBranches = false
            }
          })
        }
      },
      loadLocalities () {
        this.areLoadingLocalities = true
        const self = this
        Rails.ajax({
          url: LOCALITIES_PATH,
          type: 'GET',
          dataType: 'json',
          data: `latitude=${self.position.latitude}&longitude=${self.position.longitude}`,
          success: (localities) => {
            self.localities = localities
            if (Array.isArray(self.localities) && self.localities.length > 0 && !self.selectedLocalityId) {
              const selectedLocality = self.localities.find((l) => l.nearest)
              if (selectedLocality) {
                self.selectedLocalityId = selectedLocality.id
              } else {
                self.selectedLocalityId = self.localities[0].id
              }
            } else {
              self.loadBranches()
            }
          },
          error: (error) => {
            console.error('Error creating order: ', error)
          },
          complete: () => {
            self.areLoadingLocalities = false
          }
        })
      },
      updateMapURL () {
        if (this.selectedBranchId && Array.isArray(this.branches) && this.branches.length > 0) {
          const selectedBranch = this.branches.find((b) => b.id === this.selectedBranchId)
          if (selectedBranch) {
            this.mapUrl = selectedBranch.map_url
          }
        }
      }
    }
  })
}
